import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import socket from '@/socket/socket';
import { getGeneralSetting } from '@/redux/actions';

export const useGeneralSettingRealtime = ({ customerId }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!customerId) {
            return;
        }

        const handleGeneralSettingsChanged = ({ id, action }) => {
            console.log('<<<General Settings changed:', id, customerId, action);
            dispatch(getGeneralSetting(true));
        };

        socket.on('general-setting:changed', handleGeneralSettingsChanged);

        return () => {
            socket.off('general-setting:changed', handleGeneralSettingsChanged);
        };

    }, [customerId, dispatch]);
};